module.exports = __webpack_public_path__ + "static/media/81vumDv6LAL._AC_UX569_.405bc631.jpg";